export const colorScheme = state => state.colorScheme;
export const showAnnouns = state => state.showAnnouns;
export const showNotifs = state => state.showNotifs;
export const showRems = state => state.showRems;
export const providerFeatures = state => state.providerFeatures;
export const clientFeatures = state => state.clientFeatures;
export const documentTypes = state => state.document_types;